var React = require('react');

function ArrowRoundedLeft6x9 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_309_517)","key":0},[React.createElement("path",{"d":"M2.89844 12H20.8984","stroke":"#0D47A1","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8.89842 18L2.89844 12L8.89842 6","stroke":"#0D47A1","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_309_517"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

ArrowRoundedLeft6x9.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowRoundedLeft6x9;

ArrowRoundedLeft6x9.default = ArrowRoundedLeft6x9;
